import { PreMatchPredictionsController } from "./pre-match-predictions.controller";
import "./pre-match-predictions.style.scss";

const preMatchPredictionsDirective = function(): Record<string, any> {
	return {
		scope: {
			withinMatch: "<?",
			match: "<",
			h2hBettingDataUnavailable: "<?",
			totalDataUnavailable: "<?",
			btsDataUnavailable: "<?",
			lineDataUnavailable: "<?",
			firstSetDataUnavailable: "<?",
			highOpenDataUnavailable: "<?",
			fourOversDataUnavailable: "<?",
			firstWicketDataUnavailable: "<?",
			mostSixesDataUnavailable: "<?",
			displayMode: "<?",
			awayBeforeHome: "<?",
			articleLink:"<?",
		},
		bindToController: true,
		controller: PreMatchPredictionsController,
		controllerAs: "ppc",
		restrict: "E",
		template: require("./pre-match-predictions.template.html")
	};
};

export default preMatchPredictionsDirective;